// extracted by mini-css-extract-plugin
export default {"UploadName":"FormUpload-component_UploadName__DNnuX"};